import { ForwardRefComponent } from '@fluentui/react-components';
import * as React from 'react';

import { applyStyles } from './InputSection.styles';
import { InputSectionProps } from './InputSection.types';
import { renderInputSection_unstable } from './renderInputSection';
import { useInputSectionState_unstable } from './useInputSectionState';

export const InputSection: ForwardRefComponent<InputSectionProps> = React.forwardRef((props, ref) => {
  const state = useInputSectionState_unstable(props, ref);
  applyStyles(state);
  return renderInputSection_unstable(state);
});
